<div class="sts-icon">
  <fa-icon [icon]="iconDefinition" class="text-white" style="font-size: 40px;"></fa-icon>
</div>
<h4 class="sts-num text-white fw-semibold mb-1">{{ count$ | async | number:'1.0-0' }}</h4>
<div class="sts-title text-light">{{ name }}</div>
